import React, { Fragment } from 'react';

import FormButton from './FormButton';
import NonFieldFormErrors from './NonFieldFormErrors';

function FormFooter({ submitButtonLabel, submitButtonDisabled }) {
  return (
    <Fragment>
      <NonFieldFormErrors />
      <FormButton label={submitButtonLabel} disabled={submitButtonDisabled} />
    </Fragment>
  );
}

FormFooter.propTypes = {
  submitButtonLabel: FormButton.propTypes.label,
  submitButtonDisabled: FormButton.propTypes.disabled,
};

export default FormFooter;
